import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { ComponentsDispatch } from '../store';
import { setterGantItems } from '../store/slices/gantItemsSlice';
import { ItemType } from '../types';

const useEffectBuffer = (
    callback: React.EffectCallback,
    timeout: number = 100,
    deps: React.DependencyList,
    id?: 'useSaveToServer',
) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (id === 'useSaveToServer') {
            const [itemList] = deps as ItemType[][];
            if (itemList.length) {
                dispatch(setterGantItems({ wasChanged: true }));
            }
        }

        if (timeoutRef?.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(callback, timeout);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, deps);

    return null;
};

export default useEffectBuffer;
